// Mapeia códigos de erro do callback OAuth (worker `auth/errors.ts`) pra
// mensagens pt-BR exibidas em toast no /auth/connect. Toast é só erro
// (convenção do projeto). Código desconhecido cai no fallback genérico.
// Roteiro Fase 1 §C.7.

const MESSAGES = {
  state_mismatch: 'Sessão de login expirou. Tente conectar novamente.',
  oauth_denied: 'Você cancelou a autorização. Reconecte quando quiser.',
  oauth_provider_error: 'A plataforma está indisponível no momento. Tente em alguns minutos.',
  identity_fetch_failed: 'Não conseguimos identificar sua conta. Tente novamente.',
  account_conflict: 'Essa conta já pertence a outro perfil. Faça logout e tente novamente.',
  platform_already_linked: 'Seu perfil já tem essa plataforma conectada. Desconecte ela primeiro.',
  internal: 'Algo deu errado. Tente novamente em alguns minutos.',
} as const;

export type OAuthErrorCode = keyof typeof MESSAGES;

const FALLBACK = MESSAGES.internal;

export function oauthErrorMessage(code: string | null | undefined): string {
  if (!code) return FALLBACK;
  return (MESSAGES as Record<string, string>)[code] ?? FALLBACK;
}
